import React, { useEffect, useState } from 'react'
import { createStyles, makeStyles, Theme } from '@zn-material-ui'
import classnames from 'classnames'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    '@global': {
      boxSizing: 'border-box',
    },
    antSpin: {
      boxSizing: 'border-box',
      margin: '0',
      padding: '0',
      fontSize: '14px',
      fontVariant: 'tabular-nums',
      lineHeight: '1.5715',
      listStyle: 'none',
      fontFeatureSettings: 'tnum"',
      position: 'absolute',
      display: 'none',
      color: theme.palette.primary.main,
      textAlign: 'center',
      verticalAlign: 'middle',
      opacity: 0,
      transition: 'transform .3s cubic-bezier(.78,.14,.15,.86)',
    },
    antSpinSpinning: (props: any) => ({
      display: 'inline-block',
      opacity: 1,
      // position: 'static'
      position: 'absolute',
      zIndex: 999,
      top: '50%',
      left: '50%',
      transform: 'translateX(-50%) translateY(-50%)',
      visibility: props.spinning ? 'visible' : 'hidden',
    }),
    antSpinDot: {
      position: 'relative',
      display: 'inline-block',
      fontSize: '20px',
      width: 20,
      height: 20,
    },
    antSpinDotSpin: {
      transform: 'rotate(45deg)',
      animation: 'antRotate 1.2s linear infinite',
    },
    antSpinDotItem: {
      position: 'absolute',
      display: 'block',
      width: 9,
      height: 9,
      backgroundColor: theme.palette.primary.main,
      borderRadius: '100%',
      transform: 'scale(.75)',
      transformOrigin: '50% 50%',
      opacity: 0.3,
      animation: 'antSpinMove 1s linear infinite alternate',
      '&:first-child': {
        top: 0,
        left: 0,
      },
      '&:nth-child(2)': {
        top: '0',
        right: '0',
        animationDelay: '.4s',
      },
      '&:nth-child(3)': {
        right: '0',
        bottom: '0',
        animationDelay: '.8s',
      },
      '&:nth-child(4)': {
        bottom: '0',
        left: '0',
        animationDelay: '1.2s',
      },
    },
    '@keyframes antRotate': {
      to: {
        transform: 'rotate(405deg)',
      },
    },
    '@keyframes antSpinMove': {
      to: {
        opacity: 1,
      },
    },
  })
)

const Spin: React.FC<{ spinning?: boolean }> = props => {
  const [spinning, setSpinging] = useState(false)
  const styles = useStyles({ spinning })
  useEffect(() => {
    if (!props.spinning) {
      setTimeout(() => {
        setSpinging(false)
      }, 2000)
      return
    }
    setSpinging(true)
  }, [props.spinning])
  return (
    <>
      <div className={classnames(styles.antSpin, styles.antSpinSpinning)}>
        <span className={classnames(styles.antSpinDot, styles.antSpinDotSpin)}>
          <i className={styles.antSpinDotItem} />
          <i className={styles.antSpinDotItem} />
          <i className={styles.antSpinDotItem} />
          <i className={styles.antSpinDotItem} />
        </span>
      </div>
    </>
  )
}

Spin.defaultProps = {
  spinning: false,
}

export default Spin
